<!--
   Created by qing on 2020/2/19 2:34 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <SelectValue
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="current"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>

  <div v-else class="filter-member-container">
    <div v-if="fixedValue">
      <div
        :style="{backgroundColor: disabled ? '#F5F7FA' : '#fff'}"
        class="ry-form__dropdown-input"
        @click="openSelect">
        <div class="select-item">
          {{actionsMap[filter.fixedValue]}}
        </div>
      </div>

      <div @click.stop.prevent>
        <van-action-sheet
          v-model="show"
          get-container="body"
          @select="onSelect"
          :close-on-click-action="true"
          :actions="actions">
        </van-action-sheet>
      </div>
    </div>
    <!--固定值-->
    <ContactBox
      v-if="!filter.fixedValue || filter.fixedValue === 'fixed_value'"
      :disabled="disabled"
      :key="field.dataId"
      :fieldId="field.dataId"
      :field="field"
      :user-id="$store.state.userId"
      :company-id="$store.getters.currentCompanyId"
      :hasMember="true"
      :hasDep="false"
      :hasRole="false"
      :has-ext="false"
      :has-label="false"
      :has-current="false"
      :multiple="true"
      :selectedMember="current"
      @selectedComplete="selectedComplete"
      @change="selectChange">
    </ContactBox>
  </div>
</template>

<script>
  import current from "./mixin"
  import {FILTER_METHOD_TYPE__ALL, FILTER_METHOD_TYPE__IN, FILTER_METHOD_TYPE__NIN} from "../types";

  export default {
    mixins: [current],
    data() {
      return {
        hasMember: true,
        hasRole: false,
        hasDep: false,
        show: false,
        timeOpt: [
          {
            value: "fixed_value",
            label: "固定值"
          },
          {
            value: "current_user",
            label: "当前用户"
          }
        ],
      };
    },
    computed: {
      actions () {
        if (this.filter.method === FILTER_METHOD_TYPE__NIN ||
          this.filter.method === FILTER_METHOD_TYPE__ALL ||
          this.filter.method === FILTER_METHOD_TYPE__IN) {
          return [
            {
              id: "fixed_value",
              name: "固定值",
            },
            {
              id: "current_user",
              name: "当前用户",
            },
            {
              id: "current_and_under",
              name: "当前用户以及TA的下属",
            }
          ]
        } else {
          return [
            {
              id: "fixed_value",
              name: "固定值",
            },
            {
              id: "current_user",
              name: "当前用户",
            }
          ]
        }
      },

      actionsMap() {
        if (this.filter.method === FILTER_METHOD_TYPE__NIN ||
          this.filter.method === FILTER_METHOD_TYPE__ALL ||
          this.filter.method === FILTER_METHOD_TYPE__IN) {
          return {
            "fixed_value": "固定值",
            "current_user": "当前用户",
            "current_and_under": "当前用户以及TA的下属"
          }
        } else {
          return {
            "fixed_value": "固定值",
            "current_user": "当前用户"
          }
        }
      },
    },
    methods: {

      selectedComplete(selected) {
        this.current.splice(0, this.current.length, ...selected.memberIds)
      },
      selectChange() {
        this.filterChange()
      },
      onSelect (opt) {
        this.filter.fixedValue = opt.id
        this.current.splice(0, this.current.length)
      },
      clearData() {
        if (this.disabled) return
        this.filter.fixedValue = ''
        this.current.splice(0, this.current.length)
      },
      openSelect () {
        if (this.disabled) return
        this.show = true
      }
    }
  };
</script>

<style lang="less">
  .filter-member-container {

    .ry-form__dropdown-input {
      font-size: 14px;
      line-height: 24px;
      width: 200px;
      height: 28px;
      border: 1px solid #DCDFE6;
      border-radius: 0;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;

      .select-item {
        span {
          padding: 0 5px;
          margin-right: 5px;
          color: #ffffff;
        }
      }
    }
  }
</style>